export default "__VITE_ASSET__qvkmjQy6__"